import React from "react";
import { Button } from "@/components/ui/button";
import { Zap } from "lucide-react";

interface AutofillOption {
  label: string;
  message: string;
  type: string;
  status: string;
}

const AUTOFILL_OPTIONS: AutofillOption[] = [
  { label: "Compleet uit Ridderkerk", message: "Wij compleet uit ridderkerk", type: "order_ridderkerk", status: "actie_luijten" },
  { label: "Sikkens, jullie de rest", message: "Wij Sikkens en jullie de rest", type: "deellevering", status: "actie_luijten" },
  { label: "Anders", message: "", type: "order_ridderkerk", status: "actie_luijten" },
];

interface BulkAutofillButtonsProps {
  activeLabel: string | null;
  onSelect: (option: { message: string; type: string; status: string; label: string }) => void;
}

const BulkAutofillButtons = ({ activeLabel, onSelect }: BulkAutofillButtonsProps) => {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium flex items-center gap-1.5 text-muted-foreground">
        <Zap className="h-3.5 w-3.5" />
        Automatisch invullen
      </p>
      <div className="flex flex-wrap gap-2">
        {AUTOFILL_OPTIONS.map((opt) => (
          <Button
            key={opt.label}
            type="button"
            size="sm"
            variant={activeLabel === opt.label ? "default" : "outline"}
            onClick={() => onSelect(opt)}
            className="text-xs"
          >
            {opt.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default BulkAutofillButtons;
